import { combineReducers } from 'redux';
import accountReducer from 'src/store/reducers/accountReducer';
import providerReducer from 'src/store/reducers/providerReducer';
import partnerReducer from 'src/store/reducers/partnerReducer';
import distributorReducer from 'src/store/reducers/distributorReducer';

const rootReducer = combineReducers({
  account: accountReducer,
  provider: providerReducer,
  partner: partnerReducer,
  distributor: distributorReducer
});

export default rootReducer;
